import Checkbox from "@rio-cloud/rio-uikit/components/checkbox/Checkbox";
import { IAsset } from "../../../services/memoryAssetService";
import { useMemo } from "react";

import '../styles.scss';

const FIELD_CAMPAIGN_GROUP_ID = "field-campains-group";
const FIELD_CAMPAIGN_LABEL = "Ação de oficina AT 035-26";

interface UptimeAssetRow {
	tagName: string;
	isChecked: boolean;
	asset: IAsset;

	onAssetSelect: (assetId: string) => void;
}

const UptimeAssetRow = ({ asset, isChecked, tagName, onAssetSelect }: UptimeAssetRow) => {
	const className = useMemo(() => `TreeLeaf form-group margin-bottom-0 ${tagName == "search-results-sidebar" ? "search" : ""}`, [tagName]);
	const isFieldCampaignAsset = asset.groupIds?.includes(FIELD_CAMPAIGN_GROUP_ID) ?? false;

	return (
		<div className={className} data-key={asset.id}>
			<Checkbox className="TreeCheckbox" checked={isChecked} onChange={() => onAssetSelect(asset.id)} />
			<span className="TreeLabel">
				<span className="TreeLabelName !pr-0">
					<span className={`rioglyph rioglyph-${asset.vehicleType}`}></span>
					<span className="TreeLabelNameText">
						<span className="TreeLabelNameTextHeadline">{asset.name}</span>
						{isFieldCampaignAsset && (
							<span className="TreeLabelNameTextSubline">{FIELD_CAMPAIGN_LABEL}</span>
						)}
					</span>
				</span>
			</span>
		</div>
	);
};

export default UptimeAssetRow;
